(() => {
  angular
    .module('app.campaign')
    .controller('ListController', List);

  List.$inject = [
    '$q',
    '$scope',
    '$cookies',
    'Label',
    'ModalService',
    'CampaignService',
  ];

  function List(
    $q,
    $scope,
    $cookies,
    Label,
    ModalService,
    CampaignService,
  ) {
    const vm = this;

    vm.isIRBetaOn = $('#current-user').data('feature-irbeta') === 1;
    vm.length = 0;
    vm.loaded = false;

    vm.isStandard = type => type === 'standard';

    const companyId = $('#current-user').data('company-id');
    const SEARCH_KEY = `Labels${companyId}Search`;
    vm.search = localStorage.getItem(SEARCH_KEY) || '';

    $scope.$watch(() => vm.search,
      search => {
        if (!search) {
          localStorage.removeItem(SEARCH_KEY);
        } else {
          localStorage.setItem(SEARCH_KEY, search);
        }
      }, true);

    const FILTER_KEY = `Labels${companyId}Filter`;
    const activeLabels = localStorage.getItem(FILTER_KEY);
    let selectedLabels = activeLabels ? JSON.parse(activeLabels) : [];

    vm.filter = {
      loaded: false,
      activeLabelNames: selectedLabels,
      mode: 'and',
      type: 'all',
      getCampaignsByLabels: function () {
        vm.filter.loaded = false;
        Label.query(function (result) {
          vm.filter.allLabelNames = result.data;
          vm.filter.loaded = true;

          const availableLabels = selectedLabels.filter(label => vm.filter.allLabelNames.includes(label));
          const hasWrongLabels = selectedLabels.some(label => !vm.filter.allLabelNames.includes(label));

          if (hasWrongLabels) {
            localStorage.setItem(FILTER_KEY, JSON.stringify(availableLabels));
            vm.filter.activeLabelNames = availableLabels;
            selectedLabels = availableLabels;
            activate();
          }
        });
      },
      setTypeFilter: function (type) {
        vm.filter.type = type;
        vm.pager.reset();
      },
      switchMode: function () {
        vm.filter.mode = (vm.filter.mode == 'or') ? 'and' : 'or';
        if (vm.filter.activeLabelNames.length > 1) {
          vm.pager.reset();
        }
      },
      isActive: function (labelName) {
        var labelName = labelName.toLowerCase();
        var i = _.indexOf(vm.filter.activeLabelNames, labelName);
        return i != -1;
      },
      reset: function () {
        localStorage.removeItem(FILTER_KEY);

        vm.filter.activeLabelNames = [];
        vm.filter.getCampaignsByLabels();
      },
      toggle: function (labelName) {
        var labelName = labelName.toLowerCase();
        var i = _.indexOf(vm.filter.activeLabelNames, labelName);
        if (i == -1) {
          vm.filter.activeLabelNames.push(labelName);
        } else {
          vm.filter.activeLabelNames.splice(i, 1);
        }

        if (vm.filter.activeLabelNames.length === 0) {
          localStorage.removeItem(FILTER_KEY);
        } else {
          localStorage.setItem(FILTER_KEY, JSON.stringify(vm.filter.activeLabelNames));
        }

        vm.pager.reset();
      }
    };


    /* ------------------------------
     pagination of campaigns
     --------------------------------*/
    vm.pager = {
      maxSize: 5, // how many pages to display
      itemsPerPage: 20,
      currentPage: 1,
      totalItems: 0,
      changePage: function () {
        vm.pager.getPaginatedCampaigns(vm.pager.itemsPerPage, vm.pager.currentPage - 1, vm.predicate, !vm.orderDesc);
      },
      getPaginatedCampaigns: function (itemsPerPage, currentPage, sortPredicate, isSortOrderAscending) {
        vm.loaded = false;
        var filters = {
          labels: vm.filter.activeLabelNames,
          operator: vm.filter.mode,
          type: vm.filter.type,
        };

        window.mixpanel && window.mixpanel.track("Campaign list", filters);

        var campaignPromise = CampaignService.getPaginated(
          currentPage,
          itemsPerPage,
          sortPredicate,
          isSortOrderAscending,
          filters,
        );

        campaignPromise.then(response => {
          if (angular.isDefined(response.error)) {
            vm.error = response.error;
          } else {
            vm.campaigns = response.data;
            vm.pager.totalItems = response.meta ? response.meta.totalCount : 0;
          }
          vm.loaded = true;
        });
      },
      reset: function () {
        vm.pager.currentPage = 1;
        vm.pager.getPaginatedCampaigns(vm.pager.itemsPerPage, vm.pager.currentPage - 1, vm.predicate, !vm.orderDesc);
      }
    };

    activate();

    function activate() {
      if (angular.isUndefined($cookies.get('sortingVar'))) $cookies.put('sortingVar', 'creation-date');
      if (angular.isUndefined($cookies.getObject('sortingOrder'))) $cookies.putObject('sortingOrder', true);

      vm.predicate = $cookies.get('sortingVar');
      vm.orderDesc = $cookies.getObject('sortingOrder');

      vm.filter.getCampaignsByLabels();
      vm.pager.reset();
    }

    vm.sortBy = function (newPredicate) {
      if (vm.predicate == newPredicate) {
        vm.orderDesc = !vm.orderDesc;
        $cookies.putObject('sortingOrder', vm.orderDesc);
      } else {
        $cookies.put('sortingVar', newPredicate);
        vm.predicate = newPredicate;
        vm.orderDesc = !vm.orderDesc;
        $cookies.putObject('sortingOrder', vm.orderDesc);
      }
      vm.pager.reset();
    };

    vm.isAllChecked = function () {
      return _.every(vm.campaigns, function (p) {
        return p.checked;
      });
    };

    vm.toggleAll = function () {
      var c = vm.isAllChecked();
      _.each(vm.campaigns, function (p) {
        p.checked = !c;
      });
    };

    vm.isAnyChecked = function () {
      return _.some(vm.campaigns, function (p) {
        return p.checked;
      });
    };

    vm.goTo = function (url) {
      window.location.href = url;
    };

    function getCheckedCampaigns() {
      return _.filter(vm.campaigns, function (campaign) {
        return campaign.checked;
      })
    }



    /* -------------------------------------
     Call label modal to edit labels for campaigns
     ---------------------------------------*/
    vm.openLabelModal = function () {
      ModalService
        .showModal({
          templateUrl: 'assets/js/app/campaign/modals/labels.html',
          controller: 'LabelsModalController',
          controllerAs: 'labelModal',
          inputs: {
            checkedCampaigns: getCheckedCampaigns(),
            allLabelNames: vm.filter.allLabelNames,
            persistChanges: true
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function () {
            vm.filter.reset();
            vm.pager.reset();
          });
        });
    };

    /* -------------------------------------
     Call delete campaign modal to confirm deleting campaigns
     ---------------------------------------*/
    vm.openDeleteModal = function (campaign) {
      const checkedCampaigns = getCheckedCampaigns();

      function remove(campaign) {
        return CampaignService.delete(campaign).$promise;
      }

      ModalService
        .showModal({
          templateUrl: campaign && campaign.sourceFor.length !== 0 ?
            'assets/js/app/campaign/modals/deleteWithSources.html' :
            'assets/js/app/campaign/modals/delete.html',
          controller: 'DeleteModalController',
          controllerAs: 'deleteModal',
          inputs: {
            campaignCount: campaign ? 1 : checkedCampaigns.length,
            sourceFor: campaign && campaign.sourceFor,
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (result) {
            if (result) {
              if (campaign) {
                remove(campaign).then(function () {
                  vm.campaigns.splice(_.indexOf(vm.campaigns, campaign), 1);
                  Notification.onCampaignDeleted(campaign.pid, campaign.name);
                  vm.filter.reset();
                  vm.pager.reset();
                });
              } else {
                var promises = [];
                var campaignNames = [];
                angular.forEach(checkedCampaigns, function (p) {
                  promises.push(remove(p, false));
                  campaignNames.push(p.name);
                });
                // Wait on all requests to successfully finish before notifying.
                $q.all(promises).then(function () {
                  Notification.onCampaignDeletedMany(campaignNames);
                  vm.filter.reset();
                  vm.pager.reset();
                });
              }
            }
          });
        });
    };
  }
})();
